/**
 * Базовый слой стека модальных окон «на лету» (Bootstrap-модалка) — точка входа модуля: создаёт DOM окна,
 * вешает события show/shown/hide/hidden.bs.modal на хуки config и показывает окно. Готовая HTML-строка из
 * config.content вставляется при сборке без запроса; загрузка содержимого по ссылке — слой open-modal-url.js,
 * кнопки футера и AJAX отправки формы — слой open-modal-form.js (слои последовательно вызывают друг друга:
 * openModalForm → openModalUrl → openModalWindow).
 *
 * Стандартные обработчики кнопок футера лежат в отдельных файлах-плагинах (1 файл — 1 функция); каждый
 * регистрируется в реестре window.openModalWindowFunctions и вызывается из config.buttons[].onClick по
 * строковому алиасу: плагины базового слоя — в open-modal-window/, url-слоя — в open-modal-url/.
 */

// Реестр стандартных обработчиков: алиасы onClick кнопок футера + служебная функция url-слоя (load-content).
window.openModalWindowFunctions = {};
require("./open-modal-window/modal-hide"); // алиас «modal-hide»: закрыть окно

/**
 * Единственная точка вставки контента окна: перед и после вставки в .modal-body срабатывают хуки
 * onBeforeContentInsert / onAfterContentInsert из config, если заданы (опции url-слоя open-modal-url.js).
 * Используют её базовый слой (статический config.content) и url-слой (ответ GET).
 * @param {Object} config — опции окна; config.modal к этому моменту уже создан
 * @param {string} html   — содержимое для .modal-body
 */
window.openModalWindowSetContent = function (config, html) {
    if (typeof config.onBeforeContentInsert === "function") {
        config.onBeforeContentInsert(config, html);
    }
    config.modal.find(".modal-body").html(html);

    // Селекты вставленного контента — Select2 (идемпотентно: повторная инициализация безопасна).
    if (typeof window.initAdminSelects === "function") {
        window.initAdminSelects(config.modal);
    }

    if (typeof config.onAfterContentInsert === "function") {
        config.onAfterContentInsert(config, html);
    }
};

/**
 * Открывает базовое окно: создаёт Bootstrap-модалку на лету и показывает её; если задан готовый content —
 * вставляет его при сборке (окно открывается уже с содержимым, без крутилки). Контент по url не загружает —
 * это слой open-modal-url.js.
 *
 * element — элемент-триггер: сырой DOM-узел из jQuery-обработчика (this / e.currentTarget) либо объект события;
 *           если прилетел event, выдёргивается его currentTarget. Если элемента нет вовсе — null
 *           (фолбэк title по data-title просто не применяется).
 * config  — опции окна: см. defaults ниже. Разрешённый title записывается обратно в cfg, поэтому onClick кнопок
 *           и прочие хуки получают готовые значения.
 */
window.openModalWindow = function (element, config) {
    let defaults = {
        triggerElement: null, // явный элемент-триггер для callback'ов (DOM/jQuery); если не передан — аргумент element, иначе this вызова
        modal: null,          // jQuery-объект окна; создаётся здесь, передавать не нужно
        content: null,        // готовый HTML для .modal-body — вставляется при сборке без запроса (вместо загрузки по url)
        title: null,          // заголовок окна; если не передан — data-title элемента-триггера, иначе «Окно» (допускает HTML)
        titleClasses: "",     // дополнительные классы для h5.modal-title (например, цвет заголовка)
        size: "md",           // размер окна: "sm" / "md" / "lg" / "xl" (классы modal-sm/modal-lg/modal-xl, md — без класса)
        buttons: [],          // кнопки футера: [{label, classes, onClick}] — функция(jQuery-кнопка, config) или строковый алиас из openModalWindowFunctions
        onBeforeOpen: null,       // function(config, event) — до открытия окна (show.bs.modal)
        onAfterOpen: null,        // function(config, event) — после того, как окно стало видимым (shown.bs.modal)
        onBeforeClose: null,      // function(config, event) — перед закрытием (hide.bs.modal)
        onAfterClose: null        // function(config, event) — после закрытия; к этому моменту окно уже удалено из DOM
    };

    let cfg = Object.assign({}, defaults, config || {});

    // Если вместо элемента прилетел объект события, выдёргиваем из него нативный триггер (jQuery 3.x: e.currentTarget — совпавший элемент).
    element = (element && element.currentTarget) ? element.currentTarget : element;

    // Разрешение элемента-триггера для callback'ов: явный config.triggerElement → аргумент element функции → this вызова.
    cfg.triggerElement = (cfg.triggerElement && jQuery(cfg.triggerElement).length ? jQuery(cfg.triggerElement) : null) || (element && jQuery(element).length ? jQuery(element) : null) || (typeof this === "object" && this !== window && jQuery(this).length ? jQuery(this) : null);

    // Фолбэк-источник заголовка: data-title элемента-триггера.
    let trigger = (element && jQuery(element).length) ? jQuery(element) : null;
    cfg.title = cfg.title || (trigger && trigger.attr("data-title")) || "Окно";

    // Класс размера модального окна: sm/lg/xl — modal-sm/modal-lg/modal-xl, md — без класса (500px по умолчанию Bootstrap).
    let sizeClass = {sm: "modal-sm", md: "", lg: "modal-lg", xl: "modal-xl"}[cfg.size];
    if (sizeClass === undefined) {
        console.warn("[window-modal] Неизвестный размер окна: " + cfg.size + ", использован md");
        sizeClass = "";
    }

    let dialogClass = "modal-dialog modal-dialog-centered modal-dialog-scrollable" + (sizeClass ? " " + sizeClass : "");

    cfg.modal = jQuery(
        '<div class="modal fade window-modal" tabindex="-1" aria-hidden="true">' +
        '<div class="' + dialogClass + '">' +
        '<div class="modal-content border-0 shadow">' +
        '<div class="modal-header border-0 pb-0">' +
        '<h5 class="modal-title fw-bold flex-grow-1 me-2 mb-0' + (cfg.titleClasses ? " " + cfg.titleClasses : "") + '">' + cfg.title + '</h5>' +
        '<button type="button" class="btn-close flex-shrink-0" data-bs-dismiss="modal" aria-label="Закрыть"></button>' +
        '</div>' +
        '<div class="modal-body pt-2"></div>' +
        '</div>' +
        '</div>' +
        '</div>'
    );

    // Футер — только если заданы кнопки.
    if (cfg.buttons.length) {
        let footerHtml = '<div class="modal-footer border-0 pt-0">';
        for (let i = 0; i < cfg.buttons.length; i++) {
            let btn = cfg.buttons[i];
            footerHtml += '<button type="button" class="btn ' + (btn.classes || "") + '">' + btn.label + '</button>';
        }
        footerHtml += '</div>';
        cfg.modal.find(".modal-content").append(footerHtml);

        let footerBtns = cfg.modal.find(".modal-footer .btn");
        // onClick — функция вызывается напрямую с аргументами (jQuery-кнопка, config); строка — алиас из openModalWindowFunctions.
        cfg.buttons.forEach(function (btn, i) {
            footerBtns.eq(i).on("click", function (e) {
                let cb = btn.onClick;
                if (typeof cb === "function") {
                    cb(jQuery(e.currentTarget), cfg);
                    return;
                }
                if (typeof cb === "string") {
                    let fn = window.openModalWindowFunctions && window.openModalWindowFunctions[cb];
                    if (typeof fn === "function") {
                        fn(jQuery(e.currentTarget), cfg);
                        return;
                    }
                    console.warn("[window-modal] Неизвестный алиас onClick: " + cb);
                }
            });
        });
    }

    // Статический контент: вставляем при сборке, до показа — окно открывается уже с содержимым.
    if (typeof cfg.content === "string") {
        window.openModalWindowSetContent(cfg, cfg.content);
    }

    /** Вызывает хук из config по имени с аргументами (config, event); если хук не задан — ничего не делает. */
    let callHook = function (name, event) {
        let fn = cfg[name];
        if (typeof fn === "function") {
            fn(cfg, event);
        }
    };

    // События Bootstrap-модалки → хуки из config; после hidden окно удаляется из DOM.
    cfg.modal
        .on("show.bs.modal", function (event) { callHook("onBeforeOpen", event); })
        .on("shown.bs.modal", function (event) { callHook("onAfterOpen", event); })
        .on("hide.bs.modal", function (event) { callHook("onBeforeClose", event); })
        .on("hidden.bs.modal", function (event) { cfg.modal.remove(); callHook("onAfterClose", event); });

    jQuery("body").append(cfg.modal);
    cfg.modal.modal("show");
};
